// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.divMAParamSettingOpenMenu
{
    text-align: left;
    width: 100%;
    height: 28px;
    


}


.divMAFullParamSetting {
    background-color: black;
    
    width: calc(100% - 3px);
    height: 99%;
    
    
    display: flex;
    flex-direction: row;



  }



  .divMAParamSettingOpen {
  
    background-color: #050505;
    top: 0%;
    width: calc(100% - 500px);
    height: 100%;
    transform: rotate(0deg) scale(1,1);
    transition-property: transform width;
    transition-duration: var(--sidebar-transition-duration);
    overflow: hidden;

  }

  .divMAParamSettingOpenSmall {
  
    background-color: #050505;
    top: 0%;
    width: calc(100% - 300px);
    height: 100%;
    transform: rotate(0deg) scale(1,1);
    transition-property: transform width;
    transition-duration: var(--sidebar-transition-duration);
    overflow: hidden;

  }

.divMAParamSettingOpenMedium {
  
    background-color: #050505;
    top: 0%;
    width: calc(100% - 400px);
    height: 100%;
    transform: rotate(0deg) scale(1,1);
    transition-property: transform width;
    transition-duration: var(--sidebar-transition-duration);
    overflow: hidden;

  }



  .divMAParamSettingRightOpen {
  
    background-color: #050505;
    width: 500px;
    height: 100%;
    transition-property: width background-color;
    transition-duration: var(--sidebar-transition-duration);
    overflow: hidden;
  }

  .divMAParamSettingRightOpenSmall {
  
    background-color: #050505;
    width: 300px;
    height: 100%;
    transition-property: width background-color;
    transition-duration: var(--sidebar-transition-duration);
    overflow: hidden;
  }

  .divMAParamSettingRightOpenMedium {
  
    background-color: #050505;
    width: 400px;
    height: 100%;
    transition-property: width background-color;
    transition-duration: var(--sidebar-transition-duration);
    overflow: hidden;
  }

  .divMAParamSettingClose {
  
    background-color: #050505;
    top: 0%;
    width: calc(100% - 32px);
    height: 100%;
    transform: rotate(0deg) scale(1,1);
    transition-property: transform width;
    transition-duration: var(--sidebar-transition-duration);

  }



  .divMAParamSettingRightClose {
  
    background-color: #050505;
    width: 32px;
    height: 100%;
    transition-property: width background-color;
    transition-duration: var(--sidebar-transition-duration);
  }
  
  .divMAParamSettingContent
  {
    width: 99%;
    height: 94%;
    

    overflow: hidden;

    

  }`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appmediaassets/appmediaassets.css"],"names":[],"mappings":";AACA;;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;;;;AAIhB;;;AAGA;IACI,uBAAuB;;IAEvB,uBAAuB;IACvB,WAAW;;;IAGX,aAAa;IACb,mBAAmB;;;;EAIrB;;;;EAIA;;IAEE,yBAAyB;IACzB,OAAO;IACP,yBAAyB;IACzB,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,uDAAuD;IACvD,gBAAgB;;EAElB;;EAEA;;IAEE,yBAAyB;IACzB,OAAO;IACP,yBAAyB;IACzB,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,uDAAuD;IACvD,gBAAgB;;EAElB;;AAEF;;IAEI,yBAAyB;IACzB,OAAO;IACP,yBAAyB;IACzB,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,uDAAuD;IACvD,gBAAgB;;EAElB;;;;EAIA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,2CAA2C;IAC3C,uDAAuD;IACvD,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,2CAA2C;IAC3C,uDAAuD;IACvD,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,2CAA2C;IAC3C,uDAAuD;IACvD,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,OAAO;IACP,wBAAwB;IACxB,YAAY;IACZ,kCAAkC;IAClC,oCAAoC;IACpC,uDAAuD;;EAEzD;;;;EAIA;;IAEE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,uDAAuD;EACzD;;EAEA;;IAEE,UAAU;IACV,WAAW;;;IAGX,gBAAgB;;;;EAIlB","sourcesContent":["\n.divMAParamSettingOpenMenu\n{\n    text-align: left;\n    width: 100%;\n    height: 28px;\n    \n\n\n}\n\n\n.divMAFullParamSetting {\n    background-color: black;\n    \n    width: calc(100% - 3px);\n    height: 99%;\n    \n    \n    display: flex;\n    flex-direction: row;\n\n\n\n  }\n\n\n\n  .divMAParamSettingOpen {\n  \n    background-color: #050505;\n    top: 0%;\n    width: calc(100% - 500px);\n    height: 100%;\n    transform: rotate(0deg) scale(1,1);\n    transition-property: transform width;\n    transition-duration: var(--sidebar-transition-duration);\n    overflow: hidden;\n\n  }\n\n  .divMAParamSettingOpenSmall {\n  \n    background-color: #050505;\n    top: 0%;\n    width: calc(100% - 300px);\n    height: 100%;\n    transform: rotate(0deg) scale(1,1);\n    transition-property: transform width;\n    transition-duration: var(--sidebar-transition-duration);\n    overflow: hidden;\n\n  }\n\n.divMAParamSettingOpenMedium {\n  \n    background-color: #050505;\n    top: 0%;\n    width: calc(100% - 400px);\n    height: 100%;\n    transform: rotate(0deg) scale(1,1);\n    transition-property: transform width;\n    transition-duration: var(--sidebar-transition-duration);\n    overflow: hidden;\n\n  }\n\n\n\n  .divMAParamSettingRightOpen {\n  \n    background-color: #050505;\n    width: 500px;\n    height: 100%;\n    transition-property: width background-color;\n    transition-duration: var(--sidebar-transition-duration);\n    overflow: hidden;\n  }\n\n  .divMAParamSettingRightOpenSmall {\n  \n    background-color: #050505;\n    width: 300px;\n    height: 100%;\n    transition-property: width background-color;\n    transition-duration: var(--sidebar-transition-duration);\n    overflow: hidden;\n  }\n\n  .divMAParamSettingRightOpenMedium {\n  \n    background-color: #050505;\n    width: 400px;\n    height: 100%;\n    transition-property: width background-color;\n    transition-duration: var(--sidebar-transition-duration);\n    overflow: hidden;\n  }\n\n  .divMAParamSettingClose {\n  \n    background-color: #050505;\n    top: 0%;\n    width: calc(100% - 32px);\n    height: 100%;\n    transform: rotate(0deg) scale(1,1);\n    transition-property: transform width;\n    transition-duration: var(--sidebar-transition-duration);\n\n  }\n\n\n\n  .divMAParamSettingRightClose {\n  \n    background-color: #050505;\n    width: 32px;\n    height: 100%;\n    transition-property: width background-color;\n    transition-duration: var(--sidebar-transition-duration);\n  }\n  \n  .divMAParamSettingContent\n  {\n    width: 99%;\n    height: 94%;\n    \n\n    overflow: hidden;\n\n    \n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
